exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col[data-v-584c6279]{\r\n    padding-right: 0;\r\n    padding-left:0;\n}\n.submit-form-container[data-v-584c6279] {\r\n    margin-top: 12px;\n}\n.submit-button[data-v-584c6279] {\r\n    margin-top: 12px;\r\n    color: #fff;\r\n    background: #25d366;\r\n    width: 180px;\r\n    border: none;\n}\r\n\r\n", ""]);

// exports
